import { ValueSetModel } from 'models';
import { EntityService } from 'utils/entityService';
import request, { Methods } from 'utils/request';
import { Mock } from 'utils/mockDecorator';

export interface ValueSetQuery {
  code?: string[];
  lastSync?: string;
}

class ValueSetService extends EntityService {
  constructor() {
    super('value-set');
  }

  @Mock((params?: ValueSetQuery) =>
    import('mock/valueSets').then((m) => m.createMockValueSets(params?.code || ['MOCK_SET']))
  )
  async getValueSets(params?: ValueSetQuery) {
    return request<ValueSetModel[]>({
      method: Methods.GET,
      resource: this.resource,
      params,
    });
  }

  async getReportSubgroupKeys() {
    return request<string[]>({
      method: Methods.GET,
      resource: `${this.resource}/report-subgroup-keys`,
    });
  }
}

export const valueSetService = new ValueSetService();
